module.exports = __webpack_public_path__ + "static/media/logo.01ad0032.svg";